import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCredentials from './credentials.reducer';

export const selectCredentialsState = createFeatureSelector<fromCredentials.State>(
    fromCredentials.credentialsFeatureKey
);

export const selectMapsApiKey = createSelector(selectCredentialsState, (state) => state.maps.apiKey);

export const selectMapsApiLoaded = createSelector(selectCredentialsState, (state) => state.maps.loaded);
